import React, { useReducer } from 'react';
import { DateTime } from 'luxon';
import Webcam from 'react-webcam';
import { Box, Fab, IconButton, MenuItem, Modal, TextField } from '@mui/material';
import { AddAPhoto, ChevronLeft } from '@mui/icons-material';
import useMediaDevices from 'components/PhotoMaker/hook';
import { photos } from 'config/photos';
import { dataURLtoFile } from 'utils/common';


type PhotoButtonProps = {
    onFinish: (photo: File) => void,
    inline?: boolean,
}

const WebCamera = ({onFinish, inline}: PhotoButtonProps) => {
    const [open, toggle] = useReducer(open => !open, false);
    const {devices, deviceId, setDeviceId} = useMediaDevices();

    const addPhoto = (dataUri: string | null) => {
        if (!dataUri) return;
        const now = DateTime.now().toFormat('yyLLdd_HHmmss');
        onFinish(dataURLtoFile(dataUri, `IMG_${now}.jpg`));
    };

    return (
        <>
            {inline ?
                <IconButton
                    onClick={toggle}
                    aria-label="make picture"
                    size="large"
                    color="primary"
                >
                    <AddAPhoto fontSize="large"/>
                </IconButton>
                :
                <Fab
                    color="primary"
                    aria-label="make picture"
                    sx={{
                        position: "fixed",
                        bottom: (theme) => theme.spacing(2),
                        right: (theme) => theme.spacing(2)
                    }}
                    onClick={toggle}
                >
                    <AddAPhoto/>
                </Fab>
            }

                <Modal
                    open={open}
                    onClose={toggle}
                    sx={{bgcolor: 'black'}}
                >
                    <Box>
                        <Fab
                            size="small"
                            sx={{position: 'fixed', zIndex: 1300, top: 8, left: 8}}
                            onClick={toggle}
                        >
                            <ChevronLeft fontSize="small"/>
                        </Fab>

                        <Webcam
                            audio={false}
                            height={720}
                            screenshotFormat="image/jpeg"
                            width={1280}
                            videoConstraints={{
                                width: photos.largerSide,
                                height: photos.smallerSide,
                                deviceId: deviceId,
                            }}
                            style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%'}}
                        >
                            {/*
                            // @ts-ignore */}
                            {({getScreenshot}) => (
                                <IconButton
                                    sx={{position: 'fixed', top: '45%', right: '5%', zIndex: 1300}}
                                    onClick={() => addPhoto(getScreenshot())}
                                >
                                    <svg height="60" width="60">
                                        <circle cx="30" cy="30" r="30" stroke="none" strokeWidth="3" fill="white" />
                                    </svg>
                                </IconButton>
                            )}
                        </Webcam>

                        {devices.length > 1 && <TextField
                            id="deviceId"
                            select
                            value={deviceId}
                            sx={{position: 'fixed', zIndex: 1300, bottom: 0, left: '33%', bgcolor: 'white', width: '33%'}}
                            onChange={e => setDeviceId(e.target.value)}
                        >
                            {devices.map(d => <MenuItem key={d.deviceId} value={d.deviceId}>{d.label}</MenuItem>)}
                        </TextField>}
                    </Box>
                </Modal>
        </>
    );
};

export default WebCamera;
